import React from "react";

// The strip above the top bar on every ownezzy.com page: the partner programme
export default function AnnouncementBar() {
  return (
    <a className="ez-announce" href="/partner">
      <span aria-hidden="true">🤝</span>
      <span>Become our partner – <b>earn 25% commission</b> on every website you sell</span>
      <em>Join now →</em>
    </a>
  );
}
